import React, { FC, useEffect, useState } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import CourierListError from './components/CourierListError';
import { ManageCourierCtxProvider } from '@src/shared/context/manage-courier';
import CourierListMobile from './components/CourierListMobile';
import useGetFeedback from '@src/shared/hooks/use-getfeedback';
import { useTranslation } from 'react-i18next';
import ManageCouriersOrderHideTutorial from '@src/shared/components/Tutorial/tutorials/ManageCouriersOrderHideTutorial';

const couriersQueryClient = new QueryClient();
let timerID: any = null;

const CouriersPage: FC = () => {
  const [hasError, setHasError] = useState<boolean>(false);
  const showError = () => {
    setHasError(true);
  };
  const { triggerFeedbackCampaign } = useGetFeedback();
  const { i18n } = useTranslation();

  useEffect(() => {
    timerID = setTimeout(() => {
      triggerFeedbackCampaign(
        'MCP-828',
        ['da', 'no', 'ro', 'bg', 'pt', 'it', 'fr', 'nl', 'pl', 'de', 'en'],
        i18n.language
      );
    }, 15000);

    return () => {
      clearTimeout(timerID);
    };
  }, [i18n.language]);

  const content = hasError ? (
    <CourierListError />
  ) : (
    <>
      <ManageCourierCtxProvider>
        <CourierListMobile onError={showError} />
      </ManageCourierCtxProvider>{' '}
      :
    </>
  );

  return (
    <QueryClientProvider client={couriersQueryClient}>
      <ManageCouriersOrderHideTutorial />
      {content}
    </QueryClientProvider>
  );
};

export default CouriersPage;
